import NativeHostStrategy from './nmh';
import SafariAppStrategy from './safari';

export {
  NativeHostStrategy,
  SafariAppStrategy
};
